/* since getElementsByClassName is not supported in all Quirks Mode of IE, thats why we are writing this function */
// modified by jerod, 1/6/16 to be faster and handle null nodes
const getElementsByClassName = (node, className) => {
    if (!node) {
        return [];
    }
    if (node.getElementsByClassName) {
        return node.getElementsByClassName(className);
    }
    const a = [];
    const re = new RegExp(`(^| )${className}( |$)`);
    const els = node.getElementsByTagName('*');
    for (let i = 0, j = els.length; i < j; i++) {
        if (re.test(els[i].className)) {
            a.push(els[i]);
        }
    }
    return a;
};
export default getElementsByClassName;
